import { Box, Typography } from '@mui/material';
import DialogButton from '@components/DialogButton';

const CustomDialog = ({ styles, t, onClose }) => {
  return (
    <Box sx={styles.dialogBox} onClick={(e) => e.stopPropagation()}>
      <Typography sx={styles.dialogTitle}>{t('4530_chat_common.new_chat_unavailable')}</Typography>
      <Typography sx={styles.dialogDescription}>{t('4530_chat_common.it_is_currently_not_possible_to_start_a_new_chat')}</Typography>

      <Box sx={styles.buttonBox}>
        <DialogButton
          onClick={() => {
            onClose();
          }}
          variant="outlined"
          color="primary_blue"
          size="small"
        >
          <Typography sx={styles.dialogButtonText}>{t('0000_common.close')}</Typography>
        </DialogButton>
      </Box>
    </Box>
  );
};

export default CustomDialog;
